import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import SeoMeta from "../components/storefront/SeoMeta";
import { useI18n } from "../lib/i18n";

/**
 * Catch-all for unknown URLs. Without it an old link or a typo rendered an
 * empty shell, which reads as a broken site rather than a wrong address.
 */
export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="bg-[var(--adf-cream)] text-[var(--adf-ink)]" data-testid="page-not-found">
      <SeoMeta
        title={t("notfound.seo_title", "Səhifə tapılmadı")}
        description={t("notfound.seo_description", "Axtardığınız səhifə mövcud deyil.")}
      />
      <Header />
      <main id="main" className="adf-container flex min-h-[52vh] flex-col justify-center py-20 lg:py-28">
        <span className="adf-small text-[var(--adf-gray-3)]">404</span>
        <h1 className="mt-4 font-serif text-4xl italic lg:text-5xl">{t("notfound.title", "Bu səhifə mövcud deyil")}</h1>
        <p className="mt-6 max-w-xl text-[15px] leading-8 text-[var(--adf-gray-2)]">
          {t("notfound.body", "Ünvan dəyişmiş və ya parça kolleksiyadan çıxarılmış ola bilər.")}
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/shop" className="adf-cta adf-cta-dark px-7 py-3">{t("notfound.cta.shop", "Mağazaya bax")}</Link>
          <Link to="/shop" className="adf-cta adf-cta-outline px-7 py-3">{t("notfound.cta.shop", "Bütün məhsullar")}</Link>
          <Link to="/contact" className="adf-cta adf-cta-outline px-7 py-3">{t("notfound.cta.concierge", "Concierge ilə əlaqə")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
